import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BlockerFooterInlineStyles = /*#__PURE__*/function () {
  function BlockerFooterInlineStyles() {
    _classCallCheck(this, BlockerFooterInlineStyles);
  }

  _createClass(BlockerFooterInlineStyles, null, [{
    key: "footerContainer",
    value: function footerContainer(_ref) {
      var _ref$layout = _ref.layout,
          type = _ref$layout.type,
          dialogBorderRadius = _ref$layout.dialogBorderRadius,
          design = _ref.design,
          _ref$footerDesign = _ref.footerDesign,
          inheritBg = _ref$footerDesign.inheritBg,
          bg = _ref$footerDesign.bg,
          inheritTextAlign = _ref$footerDesign.inheritTextAlign,
          textAlign = _ref$footerDesign.textAlign,
          padding = _ref$footerDesign.padding,
          fontSize = _ref$footerDesign.fontSize,
          fontColor = _ref$footerDesign.fontColor,
          antiAdBlocker = _ref.customCss.antiAdBlocker;
      var style = {
        padding: padding.map(function (p) {
          return "".concat(p, "px");
        }).join(" "),
        background: inheritBg ? design.bg : bg,
        borderRadius: type === "dialog" ? "0 0 ".concat(dialogBorderRadius, "px ").concat(dialogBorderRadius, "px") : undefined,
        fontSize: +fontSize,
        color: fontColor,
        textAlign: inheritTextAlign ? design.textAlign : textAlign
      };

      if (type === "dialog" && design.borderWidth > 0) {
        style.borderBottom = "".concat(design.borderWidth, "px solid ").concat(design.borderColor);
        style.borderLeft = style.borderBottom;
        style.borderRight = style.borderBottom;
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-footer-container",
        style: style
      };
    }
  }, {
    key: "footer",
    value: function footer(_ref2) {
      var antiAdBlocker = _ref2.customCss.antiAdBlocker;
      var style = {
        margin: "auto",
        lineHeight: 1.8
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-footer",
        style: style
      };
    }
  }, {
    key: "footerSeparator",
    value: function footerSeparator(_ref3) {
      var type = _ref3.layout.type,
          design = _ref3.design,
          _ref3$footerDesign = _ref3.footerDesign,
          borderWidth = _ref3$footerDesign.borderWidth,
          borderColor = _ref3$footerDesign.borderColor,
          antiAdBlocker = _ref3.customCss.antiAdBlocker;
      var style = {
        height: +borderWidth,
        background: borderColor
      };

      if (type === "dialog" && design.borderWidth > 0) {
        style.borderLeft = "".concat(design.borderWidth, "px solid ").concat(design.borderColor);
        style.borderRight = style.borderLeft;
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-footer-separator",
        style: style
      };
    }
  }, {
    key: "footerLink",
    value: function footerLink(_ref4) {
      var _ref4$footerDesign = _ref4.footerDesign,
          fontSize = _ref4$footerDesign.fontSize,
          fontColor = _ref4$footerDesign.fontColor,
          hoverFontColor = _ref4$footerDesign.hoverFontColor,
          fontInheritFamily = _ref4$footerDesign.fontInheritFamily,
          fontFamily = _ref4$footerDesign.fontFamily,
          linkTextDecoration = _ref4.design.linkTextDecoration,
          antiAdBlocker = _ref4.customCss.antiAdBlocker;
      var isHover = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var style = {
        textDecoration: linkTextDecoration,
        fontSize: +fontSize,
        color: isHover ? hoverFontColor : fontColor,
        fontFamily: fontInheritFamily ? undefined : fontFamily,
        padding: "0 5px"
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-footer-link",
        style: style
      };
    }
  }]);

  return BlockerFooterInlineStyles;
}();

export { BlockerFooterInlineStyles };